import React, { useState, type Dispatch, type SetStateAction } from 'react';
import { IonModal, IonDatetime } from '@ionic/react';
import './style.css';
import { formatDateForInput } from '../../tools/TimeRelated';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  date: number;
  setDate: Dispatch<SetStateAction<number>>;
  setIsEditedDate?: Dispatch<SetStateAction<boolean>>;
}

const IonicCalendar: React.FC<ModalProps> = ({ isOpen, onClose, date, setDate, setIsEditedDate }) => {
  const [selectedDate, setSelectedDate] = useState<string>(formatDateForInput(date));

  const handleDateChange = (e: CustomEvent) => {
    setSelectedDate(e.detail.value);
  };

  const handleConfirm = () => {
    setDate(new Date(selectedDate).getTime());
    if (setIsEditedDate != null) setIsEditedDate(true);
    onClose();
  };

  return (
    <IonModal
      isOpen={isOpen}
      onDidDismiss={() => {
        onClose();
      }}
      id="style1-modal"
    >
      <div className="p-3 bg-white">
        <div>
          <IonDatetime value={selectedDate} onIonChange={handleDateChange} locale="fr-FR" color="rose" />
          <div className="flex justify-end">
            <button className="border-none outline-none bg-ionic-primary text-ionic-light p-2 rounded-xl font-semibold" onClick={handleConfirm}>
              Confirmer
            </button>
          </div>
        </div>
      </div>
    </IonModal>
  );
};

export default IonicCalendar;
